/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="BaseSelectorView.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.selectors");

  /**
   * The features for the other features selector, only available for profile pages.
   */
  ns.OtherFeaturesSelectorView = ns.BaseSelectorView.extend({
    name: "Other Features Selector",
    el: "#other-features-selector",
    templateSelector: "#other-features-selector-template",
    propertyName: "otherFeatureIds",

    events: {
      "change input": "onChangeUpdateModel"
    },

    onChangeUpdateModel: function() {
      var propertyValue;

      propertyValue = this.getPropertyValue();

      // Update the model
      this.model.set(this.propertyName, propertyValue);
    },

    getPropertyValue: function() {
      var $checkboxes, $checkedCheckboxes, featureIds;

      $checkboxes = this.$("input:checkbox");
      $checkedCheckboxes = $checkboxes.filter(":checked");

      if ($checkboxes.length === $checkedCheckboxes.length) {
        return ["a"];
      }

      if (!$checkedCheckboxes.length) {
        return [];
      }

      // Update the model
      featureIds = this.$("input:checked")
        .map(function() {
          return $(this).data("id");
        })
        .get();

      return featureIds;
    },

    /**
     * Initializes the model with the default values for this selector.
     * In this case, the default for other features is set to all options selected. FB 39453.
     */
    initializeModel: function() {},

    /**
     * Returns text summarizing the currently selected options for this selector.
     */
    getDataSummaryText: function() {
      return null;
    },

    updateDOM: function() {
      // Set the option corresponding to the value on the model
      var ids, $inputs;

      ids = this.model.get(this.propertyName);
      $inputs = this.$("input");

      if (!ids || !ids.length) {
        $inputs.prop("checked", false);
        return;
      }

      if (ids[0] === "a") {
        $inputs.prop("checked", true);
        return;
      }

      $inputs.each(function() {
        var $self, shouldBeChecked;

        $self = $(this);
        shouldBeChecked = _.any(ids, function(id) {
          return +id === $self.data("id");
        });

        $self.prop("checked", shouldBeChecked);
      });
    }
  });
})(jQuery, _);
